import React, { forwardRef } from 'react'

import classNames from 'classnames'

export enum SpinnerSize {
  SMALL = 'sm',
  BASE = 'base',
}

// Defines a type as "sm" | "base"
type SizeType = `${SpinnerSize}`

interface Props {
  size?: SpinnerSize | SizeType
}

const LoadingSpinner = forwardRef<HTMLDivElement, Props>(({ size }, ref) => {
  return (
    <div className="flex justify-center items-center py-4" ref={ref} data-testid="loading-spinner">
      <div
        className={classNames(
          'text-orange border-r-transparent spinner-border animate-spin inline-block rounded-full',
          {
            'w-4 h-4 border-[2px]': size === SpinnerSize.SMALL,
            'w-10 h-10 border-[3px]': size === SpinnerSize.BASE || !size,
          }
        )}
        role="status"
      />
    </div>
  )
})

export default LoadingSpinner
